(function () {
  "use strict";

  angular
    .module('branding')
    .directive('brandPreview', brandPreview);

  function brandPreview() {
    return {
      restrict: 'A',
      replace: true,
      scope: {
        pages: '=',
        carouselOptions: '='
      },
      templateUrl: 'pages/branding/template/preview.html'
    };
  }

})();
